import { PricingInfoViewItem } from "./pricing-info-view-item.model";
import { ProductState } from "./product-state.model";

export class PricingStateViewItem {
  private productState: ProductState;
  private pricingInfoViewItems: PricingInfoViewItem[] = [];
  private changed: boolean;

  public getProductState(): ProductState {
    return this.productState;
  }

  public setProductState(productState: ProductState): void {
    this.productState = productState;
  }

  public getPricingInfoViewItems(): Array<PricingInfoViewItem> {
    return this.pricingInfoViewItems;
  }

  public setPricingInfoViewItems(pricingInfoViewItems: Array<PricingInfoViewItem>): void {
    this.pricingInfoViewItems = pricingInfoViewItems;
  }

  public addPricingInfoViewItem(value: PricingInfoViewItem): void {
    this.pricingInfoViewItems.push(value);
  }

  public hasChanged(): boolean {
    return this.changed;
  }

  public setChangedStatus(value: boolean): void {
    this.changed = value;
  }
}
